import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {
  DxDataGridModule,
  DxDateBoxModule,
  DxPopupModule
} from "devextreme-angular";
import {
  PreparationConditionnementService
} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import BonLivraisonSettingsMl from "../../../../core/dtos/conditionnement/bon-livraison-settings-ml";
import ConditionnementLivraisonFermetureMl
  from "../../../../core/dtos/conditionnement/conditionnement-livraison-fermeture-ml";
import PlatErreurBonLivraisonMl from "../../../../core/dtos/gestion-production/plat-erreur-bon-livraison-ml";
import {PRINT_MODE} from "../../../../core/constants";
import {SharedModule} from "../../../../shared/shared.module";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
  selector: 'yo-print-errors-bon-livraison',
  templateUrl: './print-errors-bon-livraison.component.html',
  styleUrls: ['./print-errors-bon-livraison.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DxPopupModule,
    DxDataGridModule,
    DxDateBoxModule,
    SharedModule
  ]
})
export class PrintErrorsBonLivraisonComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  displayPlatsErrors: boolean = false;
  displayConditionnementDateErrorMessage: boolean = false;
  displayLivraisonDateErrorList: boolean = false;

  printErrors: PlatErreurBonLivraisonMl[] = [];
  conditionnementDateErrorList: any[] = [];
  livraisonDateErrorList: ConditionnementLivraisonFermetureMl[] = [];
  selectedLivraisonDateErrors: ConditionnementLivraisonFermetureMl[] = [];
  bulkSwitchingDate: Date = null;

  isMultiPlanProduction: boolean = false;

  private settings: BonLivraisonSettingsMl;
  private printMode: PRINT_MODE;
  private planProductionIdList: number[] = [];

  private subPrintErrors: Subscription;

  constructor(private readonly pcSvc: PreparationConditionnementService,
              private readonly utils: UtilsService) {
  }

  ngOnInit(): void {
    this.subPrintErrors = this.pcSvc.printErrorsBonlivraison$.subscribe(response => {
      this.printErrors = response.platsErreurs || [];
      this.conditionnementDateErrorList = response.conditionnementDateErrorList || [];
      this.livraisonDateErrorList = response.livraisonDateErrorList || [];
      this.planProductionIdList = response.planProductionIdList || [];
      this.printMode = response.printMode;
      this.settings = response.settings;
      this.isMultiPlanProduction = this.planProductionIdList.length > 1;
      this.selectedLivraisonDateErrors = [];
      this.bulkSwitchingDate = null;

      this.displayPlatsErrors = this.printErrors.length > 0;
      this.displayConditionnementDateErrorMessage = this.conditionnementDateErrorList.length > 0;
      this.displayLivraisonDateErrorList = this.livraisonDateErrorList.length > 0;
    });
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subPrintErrors);
  }

  closeErrors = (): void => {
    this.displayPlatsErrors = false;
    this.displayConditionnementDateErrorMessage = false;
    this.displayLivraisonDateErrorList = false;
    this.livraisonDateErrorList = [];
    this.selectedLivraisonDateErrors = [];
    this.bulkSwitchingDate = null;
  };

  forcePrint = (): void => {
    this.settings.switchDatesByCombination = this.livraisonDateErrorList.filter(dateError => dateError.switchingDate != null);
    this.settings.planProductionIdList = this.planProductionIdList;
    this.pcSvc.printBonLivraison(this.settings, this.printMode, true).subscribe();
    this.closeErrors();
  };

  onLivraisonErrorSelectionChanged = (event: any): void => {
    this.selectedLivraisonDateErrors = event.selectedRowsData;
  };

  applyBulkSwitchingDate = (): void => {
    if (!this.bulkSwitchingDate || this.selectedLivraisonDateErrors.length === 0) {
      return;
    }
    this.selectedLivraisonDateErrors.forEach(row => row.switchingDate = this.bulkSwitchingDate);
    this.livraisonDateErrorList = [...this.livraisonDateErrorList];
  };
}
